import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@/assets/base/base.css'
// import '@/assets/css/ant.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import md5 from 'js-md5';
import i18n from './i18n/i18n'
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false
Vue.use(ElementUI);
import AOS from 'aos';
import 'aos/dist/aos.css'; // 确保你也导入了样式文件
Vue.use(AOS.init({
  // 这里可以配置aos的默认参数，比如持续时间、延迟等
  duration: 600
}));
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
